import { Step as ModelStep } from "@redotech/redo-return-core-common/return-flow";
import { rejectFromModel } from "@redotech/redo-return-core-common/return-flow-step-from-model";
import {
  isRejectStepValid,
  RejectState,
} from "@redotech/redo-return-core-common/return-flow-step-valid";
import { STEP_TYPE_NAMES } from "@redotech/redo-return-core-common/return-flow/step-type-names";
import { BlockLayout } from "@redotech/redo-web/flowchart";
import CancelIcon from "@redotech/redo-web/icon-old/x.svg";
import * as React from "react";
import { StepType, StepTypeDetailsProps } from "../step";

export const REJECT = (
  Details: React.ComponentType<StepTypeDetailsProps<RejectState>>,
): StepType<RejectState, ModelStep.Reject> => ({
  Details: (props: StepTypeDetailsProps<RejectState>) =>
    React.createElement(Details, props),
  customTitle(state) {
    return state.customTitle;
  },
  description(state) {
    return state.message;
  },
  downstream() {
    return [];
  },
  maxDownstream() {
    return 0;
  },
  empty: { message: "" },
  layout() {
    return BlockLayout.FULL;
  },
  stepDeleted(state) {
    return state;
  },
  title: STEP_TYPE_NAMES[ModelStep.REJECT],
  valid(state) {
    return isRejectStepValid(state).valid;
  },
  fromModel(model) {
    return rejectFromModel(model);
  },
  toModel(state) {
    return {
      stepUUID: state.stepUUID,
      customTitle: state.customTitle,
      type: ModelStep.REJECT,
      message: state.message,
    };
  },
  Icon: CancelIcon,
  iconColor: "success",
});
